<template>
    <div class="login-wrapper">
        <div class="login-box">
            <div class="login-form-box">
                <div class="fms-logo">
                    <img :src="'images/common/img_login_logo.png' | setImgPath" alt="" />
                </div>
                <div class="field-box">
                    <input ref="memberId" v-model="login.memberId" type="text" placeholder="아이디" />
                </div>
                <div class="field-box">
                    <input v-model="login.password" type="password" placeholder="비밀번호 입력" />
                </div>
                <div class="btn-box">
                    <button type="button" @click="processLogin">
                        <span>로그인</span>
                    </button>
                </div>
                <div class="save-id">
                    <input id="save-id" v-model="login.autoYn" type="checkbox" class="save-id" />
                    <label for="save-id">로그인 상태 유지</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import LoginApi from '../api/LoginApi';
import { AUTO_YN, CONSTRUCTION, CONSTRUCTION_NM, JWT_REFRESH_TOKEN, JWT_TOKEN, MEMBER_ID, NAME, TYPE } from '../const';
import { getCookie, setCookie } from '../utils/cookie';
export default {
    name: 'Login',
    components: {},
    data: () => {
        return {
            login: { memberId: '', password: '', autoYn: false }
        };
    },
    computed: {
        ...mapState({})
    },
    created() {},
    mounted() {
        //ScreenHelper.setPortrait();
        this.hideLoading();
        this.login.memberId = getCookie(MEMBER_ID);
        this.login.autoYn = getCookie(AUTO_YN);
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),

        async processLogin() {
            if (!this.login.memberId) {
                alert('아이디를 입력해주세요');
                this.$refs.memberId.focus();
                return;
            }
            if (!this.login.password) {
                alert('비밀번호를 입력해주세요');
                this.$refs.password.focus();
                return;
            }
            this.login.autoYn = this.login.autoYn ? 'Y' : 'N';

            try {
                const param = {
                    memberId: this.login.memberId,
                    password: this.login.password,
                    autoYn: this.login.autoYn
                };
                const res = await LoginApi.login(param);

                const session = res.content;
                if (this.login.autoYn) {
                    setCookie(AUTO_YN, this.login.autoYn);
                    setCookie(MEMBER_ID, this.login.memberId);
                }
                localStorage.setItem(CONSTRUCTION_NM, res.content.constructionNm);
                localStorage.setItem(CONSTRUCTION, res.content.constructionName);
                localStorage.setItem(NAME, res.content.name);
                localStorage.setItem(TYPE, res.content.type);

                localStorage.setItem(JWT_TOKEN, res.content.token.token);
                localStorage.setItem(JWT_REFRESH_TOKEN, res.content.token.refreshToken);
                localStorage.setItem(MEMBER_ID, this.login.memberId);

                this.$router.push({ name: 'Main' });
            } catch (err) {
                alertDialog('오류가 발생했습니다.');
            }
        }
    }
};
</script>
